<template>
  <div id="product-p-col" v-if="currentProduct">
    <div id="product-parent">
      <div id="productimg">
        <div id="sideproduct">
          <ul
            style="transform: translateY(0px);list-style:none;margin: 0 !important;margin-inline-end: 0 !important;margin-block-start: 0 !important;padding: 0 !important;"
          >
            <li v-for="(item, i) in imgurls" :key="i">
              <div>
                <img @click="changeImage(item, i)" class="sideimagesmall" :src="item" />
              </div>
            </li>
          </ul>
        </div>
        <div id="mainimage">
          <img :src="this.currentPhotoLink" />
        </div>
      </div>
      <div id="productdes">
        <div id="subcat">{{ currentProduct.subcategory }}</div>
        <div id="maincat">{{ currentProduct.category }}</div>
        <table id="decProduct">
          <tr v-for="(item, idx) in cProductTableData" :key="idx" valign="top">
            <th>{{ item.title }}</th>
            <td>{{ item.val }}</td>
          </tr>
          <tr valign="top">
            <th>Ad Availablity</th>
            <td>Check with us for status</td>
          </tr>
          <tr v-if="currentProduct.width && currentProduct.width !== ''" valign="top">
            <th>Dimensions</th>
            <td>
              {{ currentProduct.width }} x {{ currentProduct.height }}
              {{ currentProduct.dimensionunit }}
            </td>
          </tr>
          <tr v-if="currentProduct.ad_maplink" valign="top">
            <th>Geolocation</th>
            <td>
              <a :href="currentProduct.ad_maplink" target="_blank">Show On Maps</a>
            </td>
          </tr>
          <tr v-if="currentProduct.space_desc" valign="top">
            <th>Description</th>
            <td>{{ currentProduct.space_desc }}</td>
          </tr>
        </table>

        <div class="price">
          <p style="color:black;padding-right: 10px;">Total Price:</p>

          <span style="position:relative">
            <div
              style="font-size: 14px;bottom: -7px;position: relative;"
              class="price-number"
            >&#8377;{{ currentProduct.taxedPrice.toLocaleString("en-IN") }}</div>
            <div class="price-slash"></div>
          </span>

          <span style="padding:0 5px 0 10px" class="price-number">
            &#8377;{{
            Math.round(
            currentProduct.taxedPrice -
            currentProduct.taxedPrice * (currentProduct.discount / 100)
            ).toLocaleString("en-IN")
            }}
          </span>
          <v-tooltip id="priceTT" bottom>
            <template v-slot:activator="{ on }">
              <v-icon color="primary" dark v-on="on">info</v-icon>
            </template>
            <span>
              Price is inclusive of tax
              <table>
                <tr>
                  <th>CSGT :&nbsp;</th>
                  <td>
                    ₹
                    {{
                    Number(
                    Math.round(
                    Math.round(
                    currentProduct.taxedPrice -
                    currentProduct.taxedPrice *
                    (currentProduct.discount / 100)
                    ) *
                    0.09 +
                    "e" +
                    2
                    ) +
                    "e-" +
                    2
                    ).toLocaleString("en-IN")
                    }}
                  </td>
                </tr>
                <tr>
                  <th>SGST :&nbsp;</th>
                  <td>
                    ₹
                    {{
                    Number(
                    Math.round(
                    Math.round(
                    currentProduct.taxedPrice -
                    currentProduct.taxedPrice *
                    (currentProduct.discount / 100)
                    ) *
                    0.09 +
                    "e" +
                    2
                    ) +
                    "e-" +
                    2
                    ).toLocaleString("en-IN")
                    }}
                  </td>
                </tr>
              </table>
            </span>
          </v-tooltip>
        </div>
        <div v-if="hasIoggySupport == false" class="paymentInfo2">
          <div class="support1">
            Add iOggly Support package and get the best service from experts.
            Now, iOggly Support is totally free.
            <!-- <span class="support-price">₹ 999</span> -->
            <div class="style-1">
              <del>
                <span class="amount">₹1999</span>
              </del>
              <ins>
                <span class="amount">₹0</span>
              </ins>
            </div>
          </div>
          <div class="support2">
            <img src="../assets/illustrations/supportill.svg" class="supportill" />
            <v-btn outline color="green" @click="addIogglySupport">Add Now</v-btn>
          </div>
        </div>

        <!-- <div v-if="!iogglysupportneeded == true" class="paymentInfo2">
        Ioggly Support Plus :
        <div id="iogglysupport">
          <div>Get best support and help from our side</div>
          <v-btn @click="addIogglySupport" outline color="green">Get Now @ Rs 999</v-btn>
        </div>
        </!-->

        <div id="addcartdiv" v-if="!this.$store.state.ismobile">
          <ul id="cartBtn">
            <li>
              <v-btn
                style="width:90%"
                @click="addToWishlist"
                :disabled="inWish"
                large
                color="error"
                class="product-action-btns"
              >{{ isInWish }}</v-btn>
            </li>
            <li>
              <v-btn
                style="width:90%"
                @click="addToCart"
                :disabled="inCart"
                large
                color="warning"
                class="product-action-btns"
              >{{ isInCart }}</v-btn>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="product-more-desc" v-if="currentProduct.customdesc">
      <span id="desc-head">Advertising on {{ currentProduct.ad_location }}</span>
      {{ currentProduct.customdesc }}
    </div>
    <div id="addcartdiv" v-if="this.$store.state.ismobile">
      <ul id="cartBtn">
        <li>
          <v-btn
            style="width:90%"
            @click="addToWishlist"
            :disabled="inWish"
            large
            color="error"
            class="product-action-btns"
          >{{ isInWish }}</v-btn>
        </li>
        <li>
          <v-btn
            style="width:90%"
            @click="addToCart"
            :disabled="inCart"
            large
            color="warning"
            class="product-action-btns"
          >{{ isInCart }}</v-btn>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as firebase from "firebase";
import { db } from "../main";

export default {
  name: "Product",
  data() {
    return {
      inCart: false,
      inWish: false,
      imgurls: "",
      isInWishList: false,
      // items: [
      //   {
      //     landmark: this.$store.state.selproduct.landmark,
      //     width_in_inches: this.$store.state.selproduct.width,
      //     height_in_inches: this.$store.state.selproduct.height
      //   }
      // ],
      userid: this.$store.state.uid,
      spaceid: null,
      currentProduct2: null,
      cartA: 0,
      wishA: 0,
      lCart: [],
      lCartCount: [],
      currentPhotoLink: "",
      productObj: []
    };
  },
  created() {
    Array(this.$store.state.allproducts)[0].forEach(element => {
      if (element.spaceid == this.$route.params.Pid) {
        this.currentProduct2 = element;
        this.spaceid = element.spaceid;
        this.imgurls = element.img_url;
        this.currentPhotoLink = this.imgurls[0];
      }
    });
  },
  computed: {
    cProductTableData() {
      return this.productObj;
    },
    currentProduct() {
      this.updateNow();
      return this.currentProduct2;
    },

    isInCart() {
      if (this.$store.state.localCartCount.includes(this.spaceid)) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.inCart = true;
        return "Already In Cart";
      } else {
        return "Add To Cart";
      }
    },
    isInWish() {
      if (this.$store.state.userData) {
        if (
          this.$store.state.userData.wishlist &&
          this.$store.state.userData.wishlist.includes(this.spaceid)
        ) {
          this.inWish = true;
          return "Already In Wishlist";
        } else {
          return "Add To Wishlist";
        }
      } else return "Add To Wishlist";
    },
    hasIoggySupport() {
      if (
        this.$store.state.userData &&
        this.$store.state.userData.iogglysupport == true
      ) {
        return true;
      } else if (this.$store.state.iogglysupportneeded == true) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {},
  methods: {
    formatDate(input) {
      var datePart = input.match(/\d+/g),
        year = datePart[0].substring(2), // get only two digits
        month = datePart[1],
        day = datePart[2];
      return day + "/" + month + "/" + year;
    },
    updateNow() {
      Array(this.$store.state.allproducts)[0].forEach(element => {
        if (element.spaceid == this.$route.params.Pid) {
          this.currentProduct2 = element;
          this.spaceid = element.spaceid;
          this.imgurls = element.img_url;
          this.currentPhotoLink = this.imgurls[0];
        }
      });
      for (var i in this.currentProduct2) {
        switch (i) {
          case "ad_city":
            if (this.currentProduct2[i] !== null)
              this.productObj.push({
                title: "City",
                val: this.currentProduct2[i]
              });
            break;
          case "ad_locality":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Locality",
                val: this.currentProduct2[i]
              });
            break;
          case "ad_location":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Location",
                val: this.currentProduct2[i]
              });
            break;
          case "pincode":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Pincode",
                val: this.currentProduct2[i]
              });
            break;
          case "landmark":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Landmark",
                val: this.currentProduct2[i]
              });
            break;
          case "pillarno":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Pillar No",
                val: this.currentProduct2[i]
              });
            break;

          case "flextype":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Flextype",
                val: this.currentProduct2[i]
              });
            break;
          case "illuminated":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Illuminated",
                val: this.currentProduct2[i]
              });
            break;
          case "liftno":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Lift No",
                val: this.currentProduct2[i]
              });
            break;
          case "tower_name":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Tower Name",
                val: this.currentProduct2[i]
              });
            break;
          case "highwaytype":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Highway",
                val: this.currentProduct2[i]
              });
            break;
          case "wrap_style":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Warp Style",
                val: this.currentProduct2[i]
              });
            break;
          case "ad_coverage":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Coverage Area",
                val: this.currentProduct2[i]
              });
            break;
          case "bustype":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Bus Type",
                val: this.currentProduct2[i]
              });
            break;
          case "corporation":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Corporation",
                val: this.currentProduct2[i]
              });
            break;
          case "ad_area":
            if (this.currentProduct2[i] !== null)
              this.productObj.push({
                title: "City",
                val: this.currentProduct2[i].toString()
              });
            break;

          case "ad_states":
            if (this.currentProduct2[i] !== null)
              this.productObj.push({
                title: "States",
                val: this.currentProduct2[i].toString()
              });
            break;
          case "metro_line":
            this.productObj.push({
              title: "Metro Line",
              val: this.currentProduct2[i]
            });
            break;
          case "train_type":
            this.productObj.push({
              title: "Train Type",
              val: this.currentProduct2[i]
            });
            break;
          case "panels":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "No of Panal",
                val: this.currentProduct2[i]
              });
            break;
          case "panels_desc":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Description",
                val: this.currentProduct2[i]
              });
            break;

          case "sidecover":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Side Covered",
                val: this.currentProduct2[i]
              });
            break;
          case "coaches":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "No of Coaches",
                val: this.currentProduct2[i]
              });
            break;
          case "train_no":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Train No",
                val: this.currentProduct2[i]
              });
            break;
          case "originstation":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Orign Station",
                val: this.currentProduct2[i]
              });
            break;
          case "endingstation":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "End Station",
                val: this.currentProduct2[i]
              });
            break;
          case "other":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Miscellaneous Details",
                val: this.currentProduct2[i]
              });
            break;
          case "name":
            this.productObj.push({
              title: "Name",
              val: this.currentProduct2[i]
            });
            break;
          case "language":
            this.productObj.push({
              title: "Language",
              val: this.currentProduct2[i]
            });
            break;
          case "adtype":
            this.productObj.push({
              title: "Ad Type",
              val: this.currentProduct2[i]
            });
            break;
          case "color":
            this.productObj.push({
              title: "Colour",
              val: this.currentProduct2[i]
            });
            break;
          case "ad_size":
            this.productObj.push({
              title: "Ad Size",
              val: this.currentProduct2[i]
            });
            break;
          case "railwayregion":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Region",
                val: this.currentProduct2[i]
              });
            break;
          case "eventname":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Event Name",
                val: this.currentProduct2[i]
              });
            break;
          case "eventplace":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Event Place",
                val: this.currentProduct2[i]
              });
            break;
          case "eventdate":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Event Date",
                val: this.currentProduct2[i]
              });
            break;
          case "airlinename":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Airline Name",
                val: this.currentProduct2[i]
              });
            break;

          case "ad_show":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Timing",
                val: this.currentProduct2[i]
              });
            break;
          case "ad_duration":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Ad Duration",
                val: this.currentProduct2[i]
              });
            break;

          case "ad_frequency":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Ad Frequency",
                val: this.currentProduct2[i]
              });
            break;
          case "ad_visibility":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Ad Visibility",
                val: this.currentProduct2[i]
              });
            break;

          case "screens":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "No Screens",
                val: this.currentProduct2[i]
              });
            break;
          case "screens_desc":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Screens Description",
                val: this.currentProduct2[i]
              });
            break;
          case "metro_controller":
            if (this.currentProduct2[i] !== "")
              this.productObj.push({
                title: "Metro Controller",
                val: this.currentProduct2[i]
              });
            break;

          // case "preference":
          //   this.productObj.push({
          //     title: "Name",
          //     val: this.currentProduct2[i]
          //   });
          //   break;

          default:
            break;
        }
      }

      setTimeout(() => {
        document
          .querySelectorAll(".sideimagesmall")[0]
          .classList.add("sideimageactive");
      }, 500);
    },
    changeImage(tempval, i) {
      // var elems = document.querySelectorAll(".sideimageactive");
      // if (elems !== null) {
      //   elems.classList.remove("active");
      // }
      switch (i) {
        case 0:
          var doc = document.querySelector(".sideimageactive");
          if (doc && doc.classList) {
            doc.classList.remove("sideimageactive");
          }

          document
            .querySelectorAll(".sideimagesmall")
            [i].classList.add("sideimageactive");
          break;
        case 1:
          doc = document.querySelector(".sideimageactive");
          if (doc && doc.classList) {
            doc.classList.remove("sideimageactive");
          }

          document
            .querySelectorAll(".sideimagesmall")
            [i].classList.add("sideimageactive");
          break;

        default:
          break;
      }

      this.currentPhotoLink = tempval;
    },
    addToWishlist() {
      if (this.$store.getters.isAuthenticated == true) {
        {
          if (this.wishA == 0) {
            this.wishA = 1;
            var promise = db
              .collection("orgdetails")
              .where("uid", "==", this.userid)
              .get();
            promise
              .then(querySnapshot => {
                querySnapshot.forEach(doc => {
                  db.collection("orgdetails")
                    .doc(doc.id)
                    .update({
                      wishlist: firebase.firestore.FieldValue.arrayUnion(
                        this.spaceid
                      )
                    })
                    .then(() => {
                      this.$store.dispatch("updateSnackBar", {
                        message: "Added To Wishlist"
                      });
                    });
                });
              })
              .catch(error => {
                // handle any errors here
              });
          }
        }
      } else {
        // this.showSnackbar({
        //   text: "Login first in order to add to wishlist",
        //   color: "green"
        // });
        this.$bvToast.toast("Login first in order to add to wishlist", {
          title: "Oops !",
          variant: "warning",
          solid: true,
          toaster: "b-toaster-top-center",
          appendToast: false
        });
      }
    },
    addIogglySupport() {
      this.$bvToast.toast("iOggly Support is add to your cart", {
        title: "Hi There !",
        variant: "warning",
        solid: true,
        toaster: "b-toaster-top-center",
        appendToast: false
      });
      this.$store.state.iogglysupportneeded = true;
    },
    addToCart() {
      if (this.$store.getters.isAuthenticated == true) {
        if (
          !this.$store.state.localCartCount.includes(
            this.$store.state.selproduct.spaceid
          )
        ) {
          this.$store.dispatch("updateLocalCart", {
            localCart: this.$store.state.selproduct
          });
          this.$store.dispatch("updateLocalCartCount", {
            localCartCount: this.$store.state.selproduct.spaceid
          });
        }
        db.collection("orgdetails")
          .doc(this.$store.state.docId)
          .set(
            {
              cart: this.$store.state.localCartCount
            },
            { merge: true }
          );

        // if (!this.$store.state.userData.cart.includes(this.spaceid)) {
        //   if (this.cartA == 0) {
        //     this.cartA = 1;
        //     var promise = db
        //       .collection("orgdetails")
        //       .where("uid", "==", this.userid)
        //       .get();
        //     promise
        //       .then(querySnapshot => {
        //         querySnapshot.forEach(doc => {
        //           db.collection("orgdetails")
        //             .doc(doc.id)
        //             .update({
        //               cart: firebase.firestore.FieldValue.arrayUnion(
        //                 this.spaceid
        //               )
        //             })
        //             .then(() => {
        //               this.$store.state.userData.cart.push(this.spaceid);
        //             });
        //         });
        //       })
        //       .catch(error => {
        //         // handle any errors here
        //       });
        //   }
        // } else {
        // }
        this.$store.dispatch("updateSnackBar", {
          message: "Added To Cart"
        });
      } else {
        if (
          !this.$store.state.localCartCount.includes(
            this.$store.state.selproduct.spaceid
          )
        ) {
          this.$store.dispatch("updateLocalCart", {
            localCart: this.$store.state.selproduct
          });
          this.$store.dispatch("updateLocalCartCount", {
            localCartCount: this.$store.state.selproduct.spaceid
          });
          this.$store.dispatch("updateSnackBar", {
            message: "Added To Cart"
          });
        }
        // if (this.$store.state.localCartCount != null) {
        //   if (!this.lCartCount.includes(this.spaceid)) {
        //     if (this.cartA != 1) {
        //       this.lCart.push(this.$store.state.selproduct);
        //       this.lCartCount.push(this.spaceid);
        //       this.$store.dispatch("updateLocalCart", {
        //         localCart: this.lCart.push(this.$store.state.selproduct)
        //       });
        //       this.$store.dispatch("updateLocalCartCount", {
        //         localCartCount: this.lCartCount.push(this.spaceid)
        //       });
        //       // this.$store.state.localCartCount.push(this.spaceid);
        //       // this.$store.state.localCart.push(this.$store.state.selproduct);
        //       this.cartA = 0;
        //     }
        //   }
        // } else {
        //   if (this.cartA != 1) {
        //     this.$store.dispatch("updateLocalCart", {
        //       localCart: this.$store.state.selproduct
        //     });
        //     this.$store.dispatch("updateLocalCartCount", {
        //       localCartCount: this.spaceid
        //     });
        //     this.cartA = 1;
        //   }
        // }
      }
    }
  }
};
</script>

<style scoped>
.price-slash {
  position: absolute;
  width: 100%;
  height: 0px;
  border-top: 2px solid rgb(227, 87, 87);
  transform: rotate(-7deg);
  top: 16px;
  right: 0px;
}
.style-1 {
  margin-left: 10px;
  margin-top: 10px;
}
.style-1 del {
  color: gray;
  text-decoration: none;
  position: relative;
}
.style-1 del:before {
  content: " ";
  display: block;
  width: 100%;
  border-top: 2px solid rgba(0, 0, 0, 0.8);
  height: 12px;
  position: absolute;
  bottom: 0;
  left: 1px;
  transform: rotate(0deg);
}
.style-1 ins {
  color: black;
  font-size: 23px;
  text-decoration: none;
  padding: 1em 1em 1em 0.5em;
}
@media only screen and (min-width: 700px) {
  .product-more-desc {
    display: flex;
    flex-direction: column;
    width: 80%;
    text-align: justify;
    text-align-last: left;
  }
  #desc-head {
    text-align: left;
    font-size: 19.6px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  #product-parent {
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    position: relative;
    background-color: white;
  }
  #product-p-col {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 3.925rem 2rem 2rem 2rem;
    width: 100%;
    background-color: white;
  }
  #cartBtn {
    display: flex;
    -webkit-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  #cartBtn li {
    width: 50%;
  }
  #mainimage {
    width: 100%;
    padding: 10px;
  }
  #mainimage img {
    height: 600px;
    width: 95%;
  }
  .sideimagesmall {
    width: 70px;
    height: 70px;
    background-size: contain;
    margin-bottom: 10px;
    border: 1px solid;
    padding: 6px;
  }
  .sideimageactive {
    border: 2px solid lightgreen !important;
  }
  #productimg {
    position: sticky;
    display: flex;
    flex-direction: row;
    width: 50%;
    top: 64px;
    bottom: 0;
    z-index: 2;
    -webkit-align-self: flex-start;
    -ms-flex-item-align: start;
    align-self: flex-start;
  }
  #sideproduct {
    padding: 10px 10px 0 0;
    display: flex;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    -webkit-align-content: stretch;
    -ms-flex-line-pack: stretch;
    align-content: stretch;
    position: relative;
  }
  #productdes {
    width: 50%;
    padding: 10px;
  }
  #decProduct {
    margin-left: 20px;
    width: 100%;
  }
  #decProduct th {
    font-size: 1.4em;
  }

  #decProduct td {
    font-size: 1.3em;
    word-break: break-all;
  }
  #subcat {
    font-size: 2.5em;
    font-weight: 600;
    margin-left: 20px;
  }
  #maincat {
    font-size: 1.5em;
    color: gray;
    margin-left: 20px;
    margin-bottom: 10px;
  }
  .paymentInfo2 {
    /* top: 325px; */
    padding: 8px;
    height: 11.5rem;
    position: relative;
    display: flex;
    flex-direction: row;
    width: 95%;
    border: 1px solid;
    margin-left: 8px;
    margin-bottom: 30px;
    background-color: white;
  }
  .price-number {
    font-size: 1.5rem;
    font-weight: normal;
    color: black;
  }
  #location {
    margin-top: 1em;
  }
  .addet {
    font-size: 1.15em;
    color: black;
    font-weight: bold;
    display: flex;
    width: 95%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
  }
  .addet div {
    color: black;
    font-weight: normal;
    float: right;
    text-align: left;
  }
  .price {
    color: blue;
    font-size: 1.5rem;
    font-weight: bold;
    margin-left: 20px;
    margin-top: 2rem;
    display: flex;
  }
  .material-icons {
    font-size: 18px !important;
  }
  .support1 {
    display: flex;
    width: 60%;
    flex-direction: column;
    font-size: 1.25rem;
    padding-top: 10px;
  }
  .support-price {
    margin-top: 1%;
    font-size: 3rem;
    font-weight: normal;
    margin-left: 15px;
  }
  .support2 {
    display: flex;
    width: 40%;
    flex-direction: column;
    padding-top: 10px;
  }
  .supportill {
    width: 100%;
    height: 50%;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 600px) {
  #product-parent {
    display: flex;
    flex-flow: column;
    justify-content: center;
  }
  #product-p-col {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    background-color: white;
  }
  .product-more-desc {
    display: flex;
    flex-direction: column;
    width: 95%;
    padding: 0 0 10px 5px;
    font-size: 12px;
    text-align: justify;
    text-align-last: left;
  }
  #desc-head {
    text-align: left;
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 2px;
  }
  #product-p-col {
    display: flex;
    flex-flow: column;
    justify-content: center;
    background-color: white;
  }
  #productimg {
    display: flex;
    flex-flow: column-reverse;
  }
  #sideproduct ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: row;
  }
  #sideproduct li {
    padding: 10px;
  }
  #sideproduct img {
    height: 50px;
    width: 50px;
    border: 1px solid gray;
    padding: 2px;
  }
  #mainimage img {
    width: 100%;
    height: 20rem;
    margin: 50px 0 0 0;
  }
  #decProduct {
    margin-left: 5px;
    font-size: 15px;
    width: 95%;
  }

  #decProduct td {
    word-break: break-all;
  }
  #subdesupper1 {
    width: 38%;
  }
  #subdesupper2 {
    width: 62%;
  }
  .addet {
    display: flex;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: left;
    font-size: 15px;
    color: #000;
    opacity: 1.7;
  }
  #productdes {
    margin-top: 10px;
  }
  .addet div {
    font-weight: normal;
    float: right;
    text-align: left;
    font-size: 15px;
    color: #000000;
    opacity: 0.7;
  }
  #subcat {
    padding-left: 5px;
    line-height: 20px;
    font-size: 18px;
    color: #212121;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #maincat {
    padding-left: 5px;
    font-size: 16px;
    color: #717171;
    display: inline-block;
    vertical-align: middle;
  }
  #cartBtn {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
  #cartBtn li {
    width: 45%;
  }
  #addcartdiv {
    position: sticky;
    bottom: 0;
    background: white;
    border-top: 0.1px solid rgb(192, 155, 155);
  }
  .price {
    display: flex;
    flex-flow: row;
    padding-left: 5px;
    font-size: 16px;
    padding-top: 15px;
  }
  .price p {
    font-weight: bolder;
  }
  .paymentInfo2 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row;
    flex-flow: row;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: 1px solid black;
    margin: 10px 5px;
    padding: 5px;
  }
  .support1 {
    width: 60%;
  }
  .support2 {
    width: 40%;
    display: flex;
    flex-flow: column;
    justify-content: center;
  }
  .supportill {
    width: 100%;
  }
  .product-action-btns {
    font-size: 10px !important;
  }
}
</style>
